import { EventDispatcherOptions } from "../typings";

export const getCollectorUrlFromOptions = ({
  collectorDomain,
  collectorPath,
}: EventDispatcherOptions) => {
  return `${collectorDomain}/${collectorPath}`;
};
